var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeaturedIcon = function SvgFeaturedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C141B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.992,
    d: "M2.729 4.548h3.638M4.548 2.729v3.638M5.457 15.462v2.728M6.821 16.826H4.093M19.1 10.914l-3.447-1.386a2.728 2.728 0 0 1-1.514-1.512l-1.396-3.468-1.396 3.468a2.726 2.726 0 0 1-1.513 1.512l-3.447 1.386h-.02L9.814 12.3c.689.278 1.236.824 1.513 1.513l1.396 3.468 1.396-3.468a2.726 2.726 0 0 1 1.514-1.513l3.447-1.386"
  })));
};
export { SvgFeaturedIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMmJhZjZmZTE2MDJjOTNlNDZhMGY1OWVkMzMyYmZhMjYuc3ZnIjs=";